import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthService } from './layout/shared/services/auth.service';
import { LoaderComponent } from './layout/shared/components/loader/loader.component';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, LoaderComponent],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent {

  constructor(
    private authService: AuthService,
  ) { 
    this.authService.isAuthenticated((isAuth:boolean)=> {
      if(!isAuth){
        this.authService.logout(); // If not authenticated, log out the user
      }
    });
  }

  ngOnInit() {
    // Initialize any necessary data or services here
  }
}
